import { ProspectListFiltersTabs } from "../../../../utils/AllFilterTabs";
import { indexOfObject } from "../../../../utils/ArrayUtils";
import { countSelectedFilters } from "../../utils/CountSeletectedFilters";

const initialAggregatesData = {
    tags: [],
    assigns: [],
    type: [],
    location: [],
    company: [],
    title: [],
    college: [],
    miscellaneous: [],
    graduation_year: []
}
export const initialFiltersState = {
    filtersSelected: {
        tags: [],
        assigns: [],
        type: [],
        location: [],
        company: [],
        title: [],
        college: [],
        miscellaneous: [],
        graduation_year: []
    },
    aggregatesData: initialAggregatesData,
    searchedAggregatesData: initialAggregatesData,
    popupsList: { showFilterPopup: false },
    activeFilterTab: ProspectListFiltersTabs[0],
    appliedFiltersCount: 0,
    searchTerm: '',
    allFilterTabs: ProspectListFiltersTabs,
};

export const prospectListFilterReducer = (state, action) => {
    switch (action.type) {
        case "ASSIGN_AGGREGATES_DATA":
            return {
                ...state,
                aggregatesData: { ...action.payload.aggregates },
                popupsList: { showFilterPopup: false },
                loaders: { filtersSubmitLoader: false }
            };
        case "ASSIGN_SEARCHED_AGGREGATES": {
            let { aggregates, mappedKey } = action.payload;
            let newAggregates = { ...state.searchedAggregatesData };
            newAggregates[mappedKey] = [...aggregates]
            return {
                ...state,
                searchedAggregatesData: newAggregates,
            };
        }
        case "ASSIGN_SPECIFIC_AGGREGATES_DATA":
            let aggregatesData = { ...state.aggregatesData };
            return {
                ...state,
                aggregatesData: {
                    ...aggregatesData,
                    [action.payload.filter_type]: action.payload.aggregates,
                },
            };
        case "APPLY_TEMP_FILTERS": {
            return {
                ...state,
                filtersSelected: { ...action.payload.filtersSelected },
                appliedFiltersCount: countSelectedFilters(action.payload.filtersSelected)
            };
        }
        case "SELECTED_FILTER": {
            let filtersSelected = { ...state.filtersSelected };
            let aggregatesData = { ...state.aggregatesData }
            let { mappedKey, selectedVal } = action.payload
            let selections = action.payload.selections || [...(filtersSelected[mappedKey] || [])]
            let agg_selections = [...(aggregatesData[mappedKey] || [])]
            if (!action.payload.selections) {
                let index = selections?.indexOf(selectedVal);
                let agg_index = indexOfObject(agg_selections, "term", selectedVal)
                if (index === -1) {
                    selections = [...selections, selectedVal]
                    if (agg_index === -1 && action.payload.selectedAgg)
                        agg_selections = [action.payload.selectedAgg, ...agg_selections]
                }
                else
                    selections.splice(index, 1)
            }
            aggregatesData[mappedKey] = [...agg_selections]
            let newFiltersSelected = {
                ...filtersSelected,
                [action.payload.mappedKey]: selections,
            };
            return {
                ...state,
                filtersSelected: newFiltersSelected,
                aggregatesData: aggregatesData,
                appliedFiltersCount: countSelectedFilters(newFiltersSelected)
            };
        }
        case "SELECT_ALL_FILTER": {
            let { mappedKey, tagsList, allSelect } = action.payload
            let { filtersSelected, aggregatesData } = state;
            let selections = [...(filtersSelected[mappedKey] || [])]
            let agg_selections = [...(aggregatesData[mappedKey] || [])]
            tagsList.filter(tag => tag.term !== null && tag.term !== undefined).map(tag => {
                let index = selections?.indexOf(tag.term);
                if (index === -1 && !allSelect) {
                    selections = [...selections, tag.term]
                    let aggregateNotExist = indexOfObject(aggregatesData[mappedKey], "term", tag.term) === -1
                    if (aggregateNotExist)
                        agg_selections = [tag, ...agg_selections]
                }
                if (index !== -1 && allSelect)
                    selections.splice(index, 1)
            })
            let newFiltersSelected = {
                ...filtersSelected,
                [mappedKey]: selections,
            };
            let newAggregates = {
                ...aggregatesData,
                [mappedKey]: agg_selections,
            };
            return {
                ...state,
                allSelect: !allSelect,
                filtersSelected: newFiltersSelected,
                aggregatesData: newAggregates,
                appliedFiltersCount: countSelectedFilters(newFiltersSelected)
            };
        }

        case "SELECT_AND_MODIFY": {
            let { mappedKey } = action.payload;
            let insertAt = "PREPEND"
            if (action.payload.insertAt) insertAt = action.payload.insertAt
            let newFiltersSelected = [
                ...(state.filtersSelected[mappedKey] || []),
                action.payload.data.term,
            ];
            let finalFilters = {
                ...state.filtersSelected,
                [mappedKey]: newFiltersSelected,
            };

            let appendedAggregates = []
            if (insertAt == "PREPEND") {
                appendedAggregates = [
                    action.payload.data,
                    ...state.aggregatesData[mappedKey],
                ];
            } else {
                appendedAggregates = [
                    ...state.aggregatesData[mappedKey],
                    action.payload.data,
                ];
            }

            let finalAggregates = {
                ...state.aggregatesData,
                [mappedKey]: appendedAggregates,
            };

            return {
                ...state,
                filtersSelected: finalFilters,
                aggregatesData: finalAggregates,
                appliedFiltersCount: countSelectedFilters(finalFilters)
            };
        }

        case "SET_ACTIVE_FILTER_SUB_TAB":
            let { payload } = action;
            let allFilterTabs = payload.allFilterTabs || ProspectListFiltersTabs;
            let index = indexOfObject(allFilterTabs, "tab_key", payload.activeFilterTabKey);
            let activeFilter = allFilterTabs[index];
            return { ...state, activeFilterTab: activeFilter };
        case "SET_POPUP":
            return { ...state, popupsList: { showFilterPopup: action.payload.showable } };
        case "CLEAR_SELECTED_FILTERS":
            return {
                ...state,
                filtersSelected: { ...initialFiltersState.filtersSelected },
                appliedFiltersCount: 0,
            };
        case "SET_STATE":
            return { ...state, ...action.payload }
        default:
            return { ...state };
    }
};